import { Channel } from './ChannelType';

export type GroupRole = {
  _id: string;
  name: string;
  description: string;
  _created: string;
  _updated: string;
  _createdBy?: string;
  _updatedBy?: string;
  stats: any;
  permissions: string[];
  requirements?: string[];
  externalId: string;
  externalType: string;
  isSystem?: boolean;
  isPublic?: boolean;
  settings?: any;
  maxUsers?: number | null;
  channel?: Channel;
  type?: GroupRoleTypeEnum;
  templateId?: string | null;
};

export enum GroupRoleEnum {
  StudioTeam = 'Studio Team',
  StudioPrivate = 'Studio Private',
  SquadMember = 'Squad Member',
  FlexMember = 'Flex Member',
  External = 'External',
  Tenant = 'Tenant',
}

export enum GroupRoleTypeEnum {
  Standard = 'standard',
  Special = 'special',
  Module = 'module',
}
